$(document).ready(function() {
    
    $(".arrow-navigate").on('click', function() {
        
        if ($(this).hasClass('active-arrow')) {
            
            $(".active-arrow").removeClass('active-arrow');
            $(".active-content").slideUp('fast');
            
        } else {
            var parent_div = $(this).parents('.distillery-faq-item');
            $(".active-arrow").removeClass('active-arrow');
            $(this).addClass('active-arrow');
            $(".active-content").slideUp('fast');
            parent_div.find('.content').slideDown('fast', function() {
                $(this).addClass('active-content');
            });
        }
        
    });
});